import { render, staticRenderFns } from "./inline-desc.vue?vue&type=template&id=06770fe8&"
import script from "./inline-desc.vue?vue&type=script&lang=js&"
export * from "./inline-desc.vue?vue&type=script&lang=js&"
import style0 from "./inline-desc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports